import styled from 'styled-components';

const BreadcrumbsBarStyled = styled.div`
  margin: 24px 12px 12px 12px;

  .MuiTypography-body1 {
    font-size: 23px;
    height: 23px;
    line-height: 23px;
    text-decoration: none;
  }

  .MuiBreadcrumbs-separator {
    font-size: 23px;
  }
`;

export { BreadcrumbsBarStyled };
